import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/legal/legal-page.tsx");
